module.exports = __webpack_public_path__ + "img/banner-3.670ca873.jpg";